export class EvolutionSystem {
    constructor(player, audioManager) {
        this.player = player;
        this.audioManager = audioManager;
        this.hud = null;
        
        this.evolutionOptions = [
            {
                id: 'tentacles',
                name: 'Tentacles',
                description: 'Grab and pull enemies',
                cost: 100,
                icon: '🦑'
            },
            {
                id: 'wings',
                name: 'Wings',
                description: 'Boost jump and glide',
                cost: 150,
                icon: '🦅'
            },
            {
                id: 'armor',
                name: 'Chitinous Armor',
                description: 'Reduce damage by 50%',
                cost: 200,
                icon: '🛡️'
            },
            {
                id: 'toxicSpikes',
                name: 'Toxic Spikes',
                description: 'Projectiles deal poison damage',
                cost: 160,
                icon: '☠️'
            },
            {
                id: 'regeneration',
                name: 'Regeneration',
                description: 'Slowly heal over time',
                cost: 240,
                icon: '💚'
            },
            {
                id: 'machineGun',
                name: 'Machine Gun Hands',
                description: 'Rapid fire black projectiles from both hands! 10x fire rate',
                cost: 2500,
                icon: '🔫'
            },
            {
                id: 'shock',
                name: 'Shock Damage',
                description: '5% chance to chain 2x damage to recently hit enemies (stacks!)',
                cost: 10000,
                icon: '⚡'
            }
        ];
    }
    
    setHUD(hud) {
        this.hud = hud;
    }
    
    canAfford(evolutionId) {
        const evolution = this.evolutionOptions.find(e => e.id === evolutionId);
        return evolution && this.player.essence >= evolution.cost;
    }
    
    purchaseEvolution(evolutionId) {
        const evolution = this.evolutionOptions.find(e => e.id === evolutionId);
        
        if (!evolution) {
            console.error('Evolution not found:', evolutionId);
            return false;
        }
        
        if (!this.canAfford(evolutionId)) {
            console.log('Not enough essence!');
            return false;
        }
        
        if (this.player.traits[evolutionId]) {
            console.log('Already have this evolution!');
            return false;
        }
        
        // Purchase
        this.player.essence -= evolution.cost;
        this.player.evolve(evolutionId);
        this.player.evolutionLevel++;
        
        if (this.audioManager) {
            this.audioManager.playEvolution();
        }
        
        // Show big notification
        if (this.hud) {
            this.hud.showEvolutionUnlocked(evolution.name, evolution.icon);
        }

        // Refresh shop immediately when it's open so the newly unlocked trait disappears
        if (this.hud && this.hud.shopOpen) {
            this.hud.updateShop();
        }
        
        console.log(`Evolved: ${evolution.name}`);
        return true;
    }
    
    getAvailableEvolutions() {
        return this.evolutionOptions.filter(evo => !this.player.traits[evo.id]);
    }
    
    getActiveEvolutions() {
        return this.evolutionOptions.filter(evo => this.player.traits[evo.id]);
    }
}
